<div class="representative-card">
    <p class="c11n-text-md-bold c11n-space-stack-1x">
        {{ content.addUserFlow.representativeCardHeading }}
    </p>
    <p class="c11n-space-stack-6x">
        {{
            content.addUserFlow.representativeCardParagraph
                | replaceParam: contactPersonTypePlaceHolder : supportTeam
        }}
    </p>
    <zci-advisor
        [name]="supportName"
        [phoneNumber]="phoneNumber"
        class="representative-card__details"
    ></zci-advisor>
</div>
